Object.defineProperty(exports,"__esModule",{value:true});exports.Color=exports.sortRules=exports.getRulesLoading=exports.addLoadingStateForRules=exports.getManufacturerName=exports.getWantedDeviceType=exports.extendPosition=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.














floorCanvasById=floorCanvasById;exports.





















areaCanvasById=areaCanvasById;exports.




















fixtureCanvasById=fixtureCanvasById;exports.

































































































































fixPositionName=fixPositionName;exports.





fixAction=fixAction;exports.

























































































































































isOkState=isOkState;exports.



createPositionState=createPositionState;exports.





















getMainPositionState=getMainPositionState;exports.




























































































fixPositionState=fixPositionState;var _moment=require('moment');var _moment2=_interopRequireDefault(_moment);var _model=require('../model');var _types=require('../armState/types');var _typesUpper=require('../armState/typesUpper');var _securityDeviceHealthStatus=require('../healthStatus/securityDeviceHealthStatus');var _types2=require('../complianceState/types');var _securityDevicePortsState=require('../armState/securityDevicePortsState');var _sortFixtures=require('../sorting/sortFixtures');var _sortFixtures2=_interopRequireDefault(_sortFixtures);var _stateCounters=require('../counters/stateCounters');var _sortPositions=require('../sorting/sortPositions');var _sortPositions2=_interopRequireDefault(_sortPositions);var _helper=require('../sorting/helper');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function floorCanvasById(session,fId){var floor=session.Floor.withId(fId);var floorObj=_extends({},floor.ref,{layoutPosition:(floor.layoutPositionId||{}).ref,parent:null});var areas=floor.areaIds.toModelArray();var areasExtended=areas.map(function(a){return _extends({},a.ref,{layoutPosition:(a.layoutPositionId||{}).ref,parent:floorObj,state:(0,_stateCounters.countIssuesForAreaWithSplittedAlarming)(a,true)});});return _extends({},floorObj,{areas:areasExtended});}function areaCanvasById(session,aId){var area=session.Area.withId(aId);var areaObj=_extends({},area.ref,{layoutPosition:(area.layoutPositionId||{}).ref});var fixturesExtended=(0,_sortFixtures2.default)(area.fixtureIds.toModelArray()).map(function(f){return _extends({},f.ref,{layoutPosition:(f.layoutPositionId||{}).ref,state:(0,_stateCounters.countIssuesForFixtureWithSplittedAlarming)(f),parent:areaObj});});return _extends({},areaObj,{fixtures:fixturesExtended,parent:null});}function fixtureCanvasById(session,fState,fxId,isSorted){if(!session.Fixture.hasId(fxId)){return{};}var fixture=session.Fixture.withId(fxId);var rules=sortRules(fixture.ruleIds.toRefArray().map(function(rule){return _extends({},rule,{updatedAt:(0,_moment2.default)(rule.updatedAt).format('MMM D YYYY hh:mm A')});}));var rulesLoading=getRulesLoading(fState);if(!session.LayoutPosition.hasId(fixture.ref.layoutPositionId)){return{};}var fixtureObj=_extends({},fixture.ref,{layoutPosition:(fixture.layoutPositionId||{}).ref,parent:null});var hasLocks=false;var positions=sortPositions(fixture.positionIds.toModelArray(),isSorted);var positionsExtended=positions.map(function(p){var pExtended=extendPosition(p,session,fixtureObj,rulesLoading);hasLocks=hasLocks||pExtended&&pExtended.deviceType===_types.DeviceType.LOCK;return pExtended;});return _extends({},fixture.ref,{rules:addLoadingStateForRules(rules,rulesLoading),layoutPosition:(fixture.layoutPositionId||{}).ref,positions:positionsExtended,hasLocks:hasLocks});}function sortPositions(positions,isSorted){if(isSorted){var sortedAlphabetically=positions.sort(function(a,b){return(0,_helper.alphabeticalCompare)(a.name,b.name);});return(0,_sortPositions2.default)(sortedAlphabetically);}return positions;}var extendPosition=exports.extendPosition=function extendPosition(p,session,fixtureObj,rulesLoading){var area=session.Area.hasId(fixtureObj.areaId)&&session.Area.withId(fixtureObj.areaId);var floor=session.Floor.hasId((area||{ref:{}}).ref.floorId)&&session.Floor.withId(area.ref.floorId);var _ref=session.Store.hasId((floor||{ref:{}}).ref.storeId)&&session.Store.withId(floor.ref.storeId).ref||{},storeId=_ref.id,storeName=_ref.name;var securityDevice=(p.securityDeviceId||{}).ref;var attachedDevice=getAttachedDevice(session,securityDevice);var attachedDeviceType=getAttachedDeviceType(securityDevice);var deviceType=(securityDevice||{}).deviceType;var armDeviceData=p.getArmDevice();var armDevice=armDeviceData?armDeviceData.ref:undefined;var portsState=(0,_securityDevicePortsState.getSecurityDevicePortsState)(armDeviceData,Color,session);var portsStateExtended=extendPortsWithAssignedProducts(portsState,session);var securedProduct=(portsStateExtended[0]||{}).securedProduct;var rules=p.ruleIds.toRefArray().map(function(r){return _extends({},r,{updatedAt:(0,_moment2.default)(r.updatedAt).format('MMM D YYYY hh:mm A')});});var wantedDeviceType=getWantedDeviceType(rules);var _ref2=armDevice||{},baseId=_ref2.baseId;var baseDeviceData=baseId?session.SecurityDevice.withId(baseId):{};var baseDevice=baseDeviceData?baseDeviceData.ref:undefined;var ramDevice=(session.SecurityDevice.all().filter(function(_ref3){var parentId=_ref3.parentId;return parentId===(securityDevice||{}).id;}).filter(function(_ref4){var deviceType=_ref4.deviceType;return deviceType===_types.DeviceType.RAM;}).toRefArray()||[])[0];var layoutPosition=void 0;if(session.PositionLayoutPosition.hasId(p.ref.layoutPositionId)){layoutPosition=(p.layoutPositionId||{}).ref;}return fixAction(_extends({},p.ref,{storeId:storeId,storeName:storeName,securityDevice:securityDevice,attachedDevice:attachedDevice,attachedDeviceType:attachedDeviceType,name:fixPositionName(p.ref.name,(fixtureObj||{}).name),fixtureName:(fixtureObj||{}).name,armDevice:armDevice,baseDevice:baseDevice,ramDevice:ramDevice,securedProduct:securedProduct,status:getMainPositionState(fixPositionState(p.getStates())),layoutPosition:layoutPosition,parent:fixtureObj,path:(fixtureObj||{}).name,wantedDeviceType:wantedDeviceType,deviceType:deviceType,portsState:portsStateExtended,rules:addLoadingStateForRules(rules,rulesLoading)}));};function fixPositionName(positionName,fixtureName){if(!fixtureName||!positionName)return positionName;return positionName;}function fixAction(itemData){var armStateType=(itemData.status||{}).states.armStateType;var isAlarmingLock=armStateType&&armStateType===_typesUpper.ArmState.ALARMING&&itemData.deviceType===_types.DeviceType.LOCK;if(isAlarmingLock){return _extends({},itemData,{status:_extends({},itemData.status,{action:undefined,actionTitle:undefined,actionTitleInProgress:undefined,states:_extends({},itemData.status.states,{armStateActionTitle:undefined,armStateActionTitleInProgress:undefined})})});}return itemData;}var getWantedDeviceType=exports.getWantedDeviceType=function getWantedDeviceType(rules){return((rules||[]).filter(function(rule){return rule.sourceAttribute==='security_device_type';})[0]||{}).parameter;};var getProductName=function getProductName(securedProduct,session){var productName=null;if(securedProduct.productId&&session.Product.hasId(securedProduct.productId)){productName=session.Product.withId(securedProduct.productId).ref.model;}return productName||securedProduct.otherProductName||securedProduct.name;};var getManufacturerName=exports.getManufacturerName=function getManufacturerName(securedProduct,session){var manufacturerName=null;if(securedProduct.manufacturerId&&session.Manufacturer.hasId(securedProduct.manufacturerId)){manufacturerName=session.Manufacturer.withId(securedProduct.manufacturerId).ref.name;}return manufacturerName||securedProduct.otherManufacturerName;};var extendPortsWithAssignedProducts=function extendPortsWithAssignedProducts(ports,session){return(ports||[]).map(function(port){if(!port)return;var securedProductId=port.securedProductId;if(!session.SecuredProduct.hasId(securedProductId))return port;var securedProduct=session.SecuredProduct.withId(securedProductId);return _extends({},port,{securedProduct:_extends({},securedProduct.ref,{productModel:getProductName(securedProduct.ref,session),productManufacturer:getManufacturerName(securedProduct.ref,session)})});});};var getAttachedDeviceType=function getAttachedDeviceType(securityDevice){if(!securityDevice){return null;}switch(securityDevice.deviceType){case _types.DeviceType.BASE:return _types.DeviceType.PUCK;case _types.DeviceType.PUCK:return _types.DeviceType.BASE;case _types.DeviceType.ALARM_MODULE:return _types.DeviceType.DUMB_PUCK;case _types.DeviceType.SECURE_PLUG:return _types.DeviceType.RAM;case _types.DeviceType.CX_FLEX:case _types.DeviceType.CX_FLEX_ONE_PORT:case _types.DeviceType.CX_FLEX_FOUR_PORT:return _types.DeviceType.RAM;case _types.DeviceType.BASE_V2:return _types.DeviceType.PUCK_V2;case _types.DeviceType.PROXIMITY_BASE:return _types.DeviceType.PROXIMITY_PUCK;case _types.DeviceType.NXDI_RISER:return _types.DeviceType.NXDI_PUCK;default:return null;}};var getAttachedDevice=function getAttachedDevice(session,securityDevice){if(!securityDevice){return null;}switch(securityDevice.deviceType){case _types.DeviceType.BASE:case _types.DeviceType.ALARM_MODULE:case _types.DeviceType.SECURE_PLUG:case _types.DeviceType.CX_FLEX:case _types.DeviceType.CX_FLEX_ONE_PORT:case _types.DeviceType.CX_FLEX_FOUR_PORT:case _types.DeviceType.BASE_V2:case _types.DeviceType.PROXIMITY_BASE:case _types.DeviceType.NXDI_RISER:return(session.SecurityDevice.all().filter(function(_ref5){var parentId=_ref5.parentId;return parentId===(securityDevice||{}).id;}).toRefArray()||[])[0];case _types.DeviceType.PUCK:case _types.DeviceType.DUMB_PUCK:case _types.DeviceType.RAM:case _types.DeviceType.PUCK_V2:case _types.DeviceType.PROXIMITY_PUCK:case _types.DeviceType.NXDI_PUCK:if(!securityDevice.parentId){return null;}return session.SecurityDevice.withId(securityDevice.parentId);default:return null;}};var addLoadingStateForRules=exports.addLoadingStateForRules=function addLoadingStateForRules(rules,rulesLoading){return(rules||[]).map(function(rule){return _extends({},rule,{loading:(rulesLoading||[]).includes(rule.id)});});};var getRulesLoading=exports.getRulesLoading=function getRulesLoading(fixtureState){return((fixtureState||{get:function get(){return undefined;}}).get('rulesLoading')||{toArray:function toArray(){return[];}}).toArray();};var sortRules=exports.sortRules=function sortRules(rules){return rules.sort(function(first,second){if(first.status===_types2.PositionRuleStatus.OK&&second.status===_types2.PositionRuleStatus.VIOLATION){return 1;}else if(first.status===_types2.PositionRuleStatus.VIOLATION&&second.status===_types2.PositionRuleStatus.OK){return-1;}return 0;});};function isOkState(okStates,state){return okStates.indexOf(state)>-1;}function createPositionState(type,title,since,reason,message,action,actionTitle,actionTitleInProgress){return{type:type,title:title,since:since,reason:reason,message:message,action:action,actionTitle:actionTitle,actionTitleInProgress:actionTitleInProgress};}function getMainPositionState(states){var okArmState=[_typesUpper.ArmState.ARMED,_typesUpper.ArmState.LOCKED];var okHealthState=[_securityDeviceHealthStatus.HealthStatus.HEALTHY];var okComplianceState=[_types2.ComplianceStatus.COMPLIANT];var okPowerState=[_typesUpper.PowerState.POWERED];var armStateType=states.armStateType,healthStateType=states.healthStateType,complianceStateType=states.complianceStateType,powerStateType=states.powerStateType;if(!isOkState(okArmState,armStateType)){return _extends({states:states},createPositionState(armStateType,states.armStateTitle,states.armStateSince,states.armStateReason,states.armStateMessage,states.armStateAction,states.armStateActionTitle,states.armStateActionTitleInProgress));}else if(!isOkState(okHealthState,healthStateType)){return _extends({states:states},createPositionState(healthStateType,states.healthStateTitle,states.healthStateSince,states.healthStateReason,states.healthStateMessage,states.armStateAction,states.armStateActionTitle,states.armStateActionTitleInProgress));}else if(!isOkState(okComplianceState,complianceStateType)){return _extends({states:states},createPositionState(complianceStateType,states.complianceStateTitle,states.complianceStateSince,states.complianceStateReason,states.complianceStateMessage,states.armStateAction,states.armStateActionTitle,states.armStateActionTitleInProgress));}else if(powerStateType!==undefined&&!isOkState(okPowerState,powerStateType)){return _extends({states:states},createPositionState(powerStateType,states.powerStateTitle,states.powerStateSince,states.powerStateReason,states.powerStateMessage,states.powerStateAction,states.powerStateActionTitle,states.powerStateActionTitleInProgress));}return _extends({states:states},createPositionState(armStateType,states.armStateTitle,states.armStateSince,states.armStateReason,states.armStateMessage,states.armStateAction,states.armStateActionTitle,states.armStateActionTitleInProgress));}function fixPositionState(states){var
complianceStateType=states.complianceStateType;
return _extends({},
states,{
complianceStateType:complianceStateType?
complianceStateType.toUpperCase():
undefined});

}

var Color=exports.Color={
green:'#3AB34A',
yellow:'#FF9600',
red:'#EB252A',
gray:'#DCDCDC'};